document.addEventListener('DOMContentLoaded', function () {
  class YGMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.tabs = null;
      this.items = null;
      this.buttons = null;
      this.tabHandlers = [];
      this.handleResize = this.handleResize.bind(this);
      this.init();
    }
    init() {
      this.tabs = this.querySelectorAll('.yg-collection-tab-item');
      this.items = this.querySelectorAll('.yg-right-box');
      this.buttons = this.querySelectorAll('.yg-collection-tab-item-button');
      if (this.tabs.length === 0 || this.items.length === 0) return;

      // 初始化高亮和展示
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('active', i === 0);
        if (this.items[i]) this.items[i].classList.toggle('active', i === 0);
      });
      this.updateViewAllButton(0);

      // 根据屏幕宽度设置事件
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    switchTab(index) {
      this.tabs.forEach((t, j) => t.classList.toggle('active', index === j));
      this.items.forEach((p, j) => p.classList.toggle('active', index === j));
      this.updateViewAllButton(index);
    }

    updateViewAllButton(activeIndex) {
      if (!this.buttons || this.buttons.length === 0) return;

      this.buttons.forEach((btn, i) => {
        const isActive = i === activeIndex;
        btn.hidden = !isActive;
        btn.classList.toggle('active', isActive);
      });
    }

    handleResize() {
      const isMobile = window.innerWidth < 1150;

      // 清除现有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
      this.tabHandlers = [];

      // 根据设备类型添加事件
      this.tabs.forEach((tab, i) => {
        let handler;
        let type;

        if (isMobile) {
          // 移动端：点击切换
          type = 'click';
          handler = () => this.switchTab(i);
        } else {
          // 桌面端：悬浮切换
          type = 'mouseenter';
          handler = () => this.switchTab(i);
        }

        tab.addEventListener(type, handler);
        this.tabHandlers.push({ tab, handler, type });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      // 清除所有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
    }
  }
  if (!window.customElements.get('yg-mega-menu')) {
    window.customElements.define('yg-mega-menu', YGMegaMenu);
  }

  // class YGInquiryBtn extends HTMLElement {
  //   constructor() {
  //     super();
  //     this._onClick = this._onClick.bind(this);
  //   }

  //   connectedCallback() {
  //     this.addEventListener('click', this._onClick);
  //   }

  //   disconnectedCallback() {
  //     this.removeEventListener('click', this._onClick);
  //   }

  //   _onClick() {
  //     document.dispatchEvent(new CustomEvent('yg:openInquiry'));
  //   }
  // }

  // if (!window.customElements.get('yg-inquiry-btn')) {
  //   window.customElements.define('yg-inquiry-btn', YGInquiryBtn);
  // }

  // 自定义元素：<yg-product-data-list> 在悬停时滚动到最右侧，离开时回到最左侧
  class YGProductDataList extends HTMLElement {
    constructor() {
      super();
      this._onEnter = this._onEnter.bind(this);
      this._onLeave = this._onLeave.bind(this);
    }

    connectedCallback() {
      // 延迟绑定以确保样式和尺寸已计算
      if (this._ygInit) return;
      this._ygInit = true;
      this.addEventListener('mouseenter', this._onEnter);
      this.addEventListener('mouseleave', this._onLeave);
      // always ensure mask exists so it's visible even before hover
      this._ensureMask();

      document.addEventListener('click', function (e) {
        if (e.target.closest('.yg-colse-menu')) {
          const parent = e.target.closest('[is="mega-menu-disclosure"]');
          if (parent && parent.hasAttribute('open')) {
            parent.removeAttribute('open');
          }
          const mega_menu  = e.target.closest('.mega-menu ');
          if (mega_menu) {
            mega_menu.style.removeProperty('opacity');
          }
        }
      });
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this._onEnter);
      this.removeEventListener('mouseleave', this._onLeave);
      // remove scroll listener
      if (this._hasScrollListener && this._onScroll) {
        this.removeEventListener('scroll', this._onScroll);
        this._hasScrollListener = false;
        this._onScroll = null;
      }
      // disconnect ResizeObserver
      if (this._ro) {
        try { this._ro.disconnect(); } catch (e) {}
        this._ro = null;
      }
      // cancel any running animation
      if (this._ygScrollRaf) {
        cancelAnimationFrame(this._ygScrollRaf);
        this._ygScrollRaf = null;
      }
      // remove mask if appended inside the list or inside a list-box container
      if (this._maskEl) {
        const possibleContainer = this.closest('.yg-product-data-list-box') || this;
        if (this._maskEl.parentElement === possibleContainer) {
          try { possibleContainer.removeChild(this._maskEl); } catch (e) {}
        }
      }
      this._maskEl = null;
      this._ygInit = false;
    }

    _onEnter() {
      // 仅在内容溢出时滚动并显示遮罩逻辑
      if (this.scrollWidth <= this.clientWidth) return;
      this._ensureMask();
      this._animateScrollTo(this.scrollWidth - this.clientWidth, 700);
    }

    _onLeave() {
      this._animateScrollTo(0, 700);
    }
    
    // 动画滚动到指定位置（ms），使用 easeInOutQuad
    _animateScrollTo(targetLeft, duration = 700) {
      const startLeft = this.scrollLeft;
      const change = targetLeft - startLeft;
      const startTime = performance.now();

      const easeInOutQuad = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

      const step = (now) => {
        const elapsed = now - startTime;
        const t = Math.min(1, elapsed / duration);
        const eased = easeInOutQuad(t);
        this.scrollLeft = Math.round(startLeft + change * eased);
        this._updateMaskVisibility();
        if (t < 1) {
          this._ygScrollRaf = requestAnimationFrame(step);
        } else {
          this._ygScrollRaf = null;
          this._updateMaskVisibility(true);
        }
      };

      if (this._ygScrollRaf) cancelAnimationFrame(this._ygScrollRaf);
      this._ygScrollRaf = requestAnimationFrame(step);
    }

    _ensureMask() {
      // attach mask INSIDE the nearest .yg-product-data-list-box if exists, otherwise inside this list element
      const container = this.closest('.yg-product-data-list-box') || this;
      // ensure container is positioned to allow absolute mask
      if (getComputedStyle(container).position === 'static') {
        container.style.position = 'relative';
      }

      if (!this._maskEl) {
        const mask = document.createElement('div');
        mask.className = 'yg-product-data__mask';
        mask.style.position = 'absolute';
        mask.style.right = '0';
        mask.style.width = '48px';
        mask.style.pointerEvents = 'none';
        mask.style.transition = 'opacity .25s ease';
        mask.style.background = 'linear-gradient(270deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%)';
        container.appendChild(mask);
        this._maskEl = mask;

        // ResizeObserver to keep mask position/height in sync (observe this and container if available)
        if (window.ResizeObserver) {
          this._ro = new ResizeObserver(() => this._updateMaskPosition());
          this._ro.observe(this);
          if (container !== this) this._ro.observe(container);
        }
      }

      // attach scroll listener to update mask visibility when user scrolls manually
      if (!this._hasScrollListener) {
        this._onScroll = () => this._updateMaskVisibility();
        this.addEventListener('scroll', this._onScroll, { passive: true });
        this._hasScrollListener = true;
      }

      this._updateMaskPosition();
      this._updateMaskVisibility();
    }

    _updateMaskVisibility(forceHide = false) {
      if (!this._maskEl) return;
      const atRight = (this.scrollWidth - this.clientWidth - this.scrollLeft) <= 1;
      if ( atRight) {
        this._maskEl.style.opacity = '0';
      } else {
        this._maskEl.style.opacity = '1';
      }
    }

    _updateMaskPosition() {
      if (!this._maskEl) return;
      const container = this._maskEl.parentElement;
      // compute top relative to container
      const containerRect = container.getBoundingClientRect();
      const listRect = this.getBoundingClientRect();
      const top = listRect.top - containerRect.top;
      // set top and height to cover the list area
      this._maskEl.style.top = `${Math.max(0, Math.round(top))}px`;
      this._maskEl.style.height = `${Math.round(this.offsetHeight)}px`;
    }
  }

  if (!window.customElements.get('yg-product-data-list')) {
    window.customElements.define('yg-product-data-list', YGProductDataList);
  }

  class YGPriceButton extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    _onClick(e) {
      // 找到最近的 product-card 元素或包含 .product-card 的父节点
      const productCard = this.closest('product-card') || this.closest('.product-card');
      if (!productCard) return;

      const quickBuy = productCard.querySelector('.product-card__quick-buy');
      if (!quickBuy) return;

      // 优先触发显式的提交或按钮元素
      const trigger = quickBuy.querySelector('button[type="submit"], button, a, input[type="submit"]');
      if (trigger) {
        trigger.click();
      }
    }
  }

  if (!window.customElements.get('yg-price-button')) {
    window.customElements.define('yg-price-button', YGPriceButton);
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => { 
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }

  class YGBuyButtonPrice extends HTMLElement {
    constructor() {
      super();
      this.handleResize = this.handleResize.bind(this);
      this.resizeTimer = null;
    }

    connectedCallback() {
      this.updateVisibility();
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);

      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = null;
      }
    }

    handleResize() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }

      this.resizeTimer = setTimeout(() => {
        this.updateVisibility();
      }, 80);
    }

    updateVisibility() {
      const priceList = this.querySelector('.price-list');
      if (!priceList) return;

      this.style.display = '';
      priceList.style.display = '';

      requestAnimationFrame(() => {
        const hasVisibleContent = priceList.offsetWidth > 0 || priceList.offsetHeight > 0;

        if (!hasVisibleContent) {
          this.style.display = '';
          priceList.style.display = '';
        }
      });
    }
  }

  if (!window.customElements.get('yg-buy-button-price')) {
    window.customElements.define('yg-buy-button-price', YGBuyButtonPrice)
  }

  class YGBuyItNow extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      let _this = this
      let $button = _this.querySelector('.yg-buy-it-now-button')
      $button.addEventListener('click', () => _this.buttonClick())
    }
    buttonClick() {
      // 这里放置自定义逻辑
      let buyBtn = this.querySelector('.shopify-payment-button .shopify-payment-button__more-options') || this.querySelector('.shopify-payment-button .shopify-payment-button__button');
      buyBtn.click();
    }
  }
  if (!window.customElements.get('yg-buy-it-now')) {
    window.customElements.define('yg-buy-it-now', YGBuyItNow)
  }

  function initYGProductGalleryPageCounter() {
    const galleries = document.querySelectorAll('.yg-product-gallery');

    galleries.forEach((gallery) => {
      const counter = gallery.querySelector('.yg-product-gallery__page-counter');
      const current = counter?.querySelector('.yg-product-gallery__page-current');
      const total = counter?.querySelector('.yg-product-gallery__page-total');
      const carousel = gallery.querySelector('.product-gallery__media-list');

      if (!counter || !current || !total || !carousel) return;

      let currentSlide = null;

      const getSlides = () => Array.from(carousel.querySelectorAll('.product-gallery__media'));
      const getVisibleSlides = () => {
        return getSlides().filter((item) => {
          return !item.hasAttribute('hidden') && item.classList.contains('active');
        });
      };

      const updateCounter = () => {
        const visibleSlides = getVisibleSlides();

        if (visibleSlides.length <= 1) {
          counter.hidden = true;
          return;
        }

        counter.hidden = false;
        total.textContent = String(visibleSlides.length);

        if (!currentSlide || !visibleSlides.includes(currentSlide)) {
          currentSlide = visibleSlides[0];
        }

        current.textContent = String(visibleSlides.indexOf(currentSlide) + 1);
      };

      currentSlide = getVisibleSlides()[0] || null;
      updateCounter();

      carousel.addEventListener('carousel:change', (event) => {
        const slides = getSlides();
        currentSlide = slides[event.detail.index] || currentSlide;
        updateCounter();
      });

      const observer = new MutationObserver(() => updateCounter());
      observer.observe(carousel, {
        subtree: true,
        childList: false,
        attributes: true,
        attributeFilter: ['hidden', 'class', 'aria-current']
      });
    });
  }

  initYGProductGalleryPageCounter();
})